import { render, staticRenderFns } from "./InitiativeForm.vue?vue&type=template&id=24e240ad&scoped=true"
import script from "./InitiativeForm.vue?vue&type=script&lang=js"
export * from "./InitiativeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e240ad",
  null
  
)

export default component.exports